import React from "react";
import { View, StyleSheet } from "react-native";

import Loader from "ae-base/Base/Loader";
import StyledButton from "ae-base/Base/StyledButton";
import StyledText from "ae-base/Base/StyledText";
import ConfirmationModal from "ae-base/Base/ConfirmationModal";
import CardPage from "../../../Layout/CardPage";

import Form from "ae-forms";
import ButtonSpacer from "ae-base/Base/ButtonSpacer";

import { useResources } from "@aetonix/hooks";

import FileItems from "./FileItems/FileItems";
import TextItem from "./FileItems/TextItem";

var DEFAULT_DATA = {
	title: "",
	body: "",
	files: [],
	lock: false,
};

var styles = StyleSheet.create({
	buttons:{
		flexDirection: "row",
		justifyContent: "flex-end",
	},
});

export default function ManagedformsEdit(props) {
	const {
		localize,
		dispatch,
	} = useResources();
	var model = props.model;

	var toast = model.toast;
	var manage = model.manage;
	const personal = model.personal;
	var forms = manage.forms;
	var schema = forms.schema;
	var updating = forms.updating;
	var locking = forms.locking;
	var removing = forms.removing;
	var unlocking = forms.unlocking;
	var defaultData = forms.data || DEFAULT_DATA;
	var hasSchema = forms.schema && forms.schema.properties;
	var canDelete = forms.canDelete;
	var saving = model.saving;
	var isLocked = forms.isLocked;
	const locker = forms?.locker;
	var newSchema;
	var newProperties =
		hasSchema &&
		Object.keys(schema.properties)
			?.filter((key) => key !== "lock")
			.reduce((result, key) => {
				result[key] = schema.properties[key];
				return result;
			}, {});
	var newSchema = hasSchema ? { ...schema, properties: newProperties } : {};
	var screen = model.size;

	var deletetext = localize("managedformsedit.deletetext");
	const lockText = localize("managedformsedit.lock");
	const unlockText = localize("note.unlock");
	var title = localize("managedformsedit.title");
	var confirmtext = locking
		? localize("managedformsedit.confirmlock")
		: unlocking
			? localize("managedformsedit.confirmunlock")
			: localize("managedformsedit.confirmtext");
	var canceltext =
		locking || unlocking ? localize("managedformsedit.cancellock") : localize("managedformsedit.canceltext");
	var text = locking
		? localize("managedformsedit.locktext")
		: unlocking
			? localize("managedformsedit.unlocktext")
			: localize("managedformsedit.text");
	var editnote = localize("managedformsedit.editnote");
	var discardchanges = localize("managedformsedit.discardchanges");
	var back = localize("groupforms.back");

	var deleteSubmission = dispatch("managedforms:trigger:remove:start", {
		submission: updating,
	});

	const lockSubmission = dispatch("managedforms:trigger:lock:start", {
		submission: updating,
	});

	const unlockSubmission = dispatch("managedforms:trigger:unlock:start", {
		submission: updating,
	});

	var lockButton = isLocked ? ( personal._id === locker ? (
		<StyledButton id={"notes.unlock"} title={unlockText} icon="unlock" onPress={unlockSubmission} />
	) : null ) : (
		<StyledButton id={"notes.lock"} title={lockText} icon="lock" onPress={lockSubmission} />
	);

	var deleteButton = canDelete ? (
		!isLocked ? (<StyledButton alert id={"notes.delete"} title={deletetext} icon="delete" onPress={deleteSubmission} disabled={isLocked} />) : null
	) : null;

	var buttons = (
		<View style={styles.buttons}>
			<>
				{lockButton}
				<ButtonSpacer />
				{deleteButton}
			</>
		</View>
	);

	if (!hasSchema) return <Loader />;

	var submitUpdate = dispatch("managedforms:trigger:update:submit");
	var goBack = dispatch("managedforms:trigger:cancel");

	var confirmDelete, cancelDelete, confirmLock, cancelLock, confirmUnlock, cancelUnlock;

	if (locking) {
		confirmLock = dispatch("managedforms:trigger:lock:accept", {
			submission: updating,
			locker: personal._id,
		});
		cancelLock = dispatch("managedforms:trigger:lock:cancel");
	}

	if (removing) {
		confirmDelete = dispatch("managedforms:trigger:remove:accept", {
			submission: updating,
		});
		cancelDelete = dispatch("managedforms:trigger:remove:cancel");
	}

	if (unlocking) {
		confirmUnlock = dispatch("managedforms:trigger:unlock:accept", {
			submission: updating,
		});
		cancelUnlock = dispatch("managedforms:trigger:unlock:cancel");
	}

	var confirmation = (
		<ConfirmationModal
			open={removing || locking || unlocking}
			title={title}
			titleIcon="warning"
			confirmText={confirmtext}
			cancelText={canceltext}
			onConfirm={locking ? confirmLock : unlocking ? confirmUnlock : confirmDelete}
			onCancel={locking ? cancelLock : unlocking ? cancelUnlock : cancelDelete}
			toast={toast}
		>
			<StyledText contrast>{text}</StyledText>
		</ConfirmationModal>
	);


	var renderItems = Object.keys(schema.properties)
		.filter(function (name) {
			return typeof forms.data[name] !== "undefined";
		})
		.map(function (name) {
			var property = schema.properties[name];
			var value = forms.data[name];

			if (property.type === "string") return <TextItem key={name} schema={property} content={value} screen={screen} />;

			if (property.format === "file")
				return <FileItems key={name} schema={property} files={value || []} screen={screen} />;

			return null;
		});

	if (isLocked)
		return (
			<CardPage
				title={editnote}
				icon="notebook"
				edit={buttons}
				external={confirmation}
				toast={toast}
				saving={saving}
				screen={screen}
				online={model.online}
				backTitle={back}
				backAction={goBack}
			>
				{renderItems}
			</CardPage>
		);


	return (
		<CardPage
			title={editnote}
			icon="notebook"
			edit={buttons}
			external={confirmation}
			toast={toast}
			saving={saving}
			screen={screen}
			online={model.online}
		>
			<Form
				key={updating + forms.updated_at}
				schema={newSchema}
				defaultData={defaultData}
				onSubmit={submitUpdate}
				onCancel={goBack}
				cancelText={discardchanges}
				disable={isLocked}
				noEdit={isLocked}
			/>
		</CardPage>
	);
}
